const defaultConfig = {
  clicks: {
    ir_main_navigation: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Deal Center
    deal_center_deal_create: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_deal_create_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_deal_edit_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_deal_create_cancel: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_deal_edit_cancel: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_deal_edit: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_deal_view: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_investor_view: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_investor_action: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_investor_profile_action: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_investor_custodian_view: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_prediction_view: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_prediction_make_new_prediction: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_prediction_make_new_prediction_save_as_draft: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_deal_book_view: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    deal_center_deal_book_action: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Contact Lookup
    contact_lookup_request: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contact_lookup_request_custom_search: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contact_lookup_activate_finish: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contact_lookup_stop_smart_search_proceed: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contact_lookup_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contact_lookup_payment_place_order: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contact_lookup_payment_update: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contact_lookup_payment_add_card: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Surveys
    surveys_create_new: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    surveys_overview_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    surveys_overview_recipients_list: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    surveys_create_finish: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    surveys_home_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Institutional investors
    institutional_investors_search: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_search_info: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_favorites: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_add_favorites: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_more_details: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_advanced_search: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_advanced_search_tags: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_advanced_search_filters: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_downnload_funds: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_downnload_investments: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    institutional_investors_confirm_download_fail: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Shelf Registration
    shelf_edit_chart: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shelf_edit_chart_undo: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shelf_save_chart: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shelf_prediction_mode_toggle: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shelf_prediction_mode_clear: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shelf_prediction_mode_calculate: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shelf_download_data: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Login
    login_enter: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    login_forgot: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    login_create: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    login_learn: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Password reset
    password_reset_back: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    password_reset_send: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    new_password_send: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // display blocked for payment declined
    invoice_problem_payment_declined: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    invoice_problem_update: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    invoice_problem_pay_now: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Events
    events_add: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    events_add_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    events_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // IR Firms
    firms_add: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    firms_add_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    firms_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Situation Room
    situation_reactivate_account: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    situation_reactivate_go_to_dashboard: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    situation_nav: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    situation_favorite: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shareholders_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shareholders_lookup: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shareholders_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shareholders_lookup_payment_add_card: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shareholders_lookup_payment_update: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shareholders_lookup_payment_place_order: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Insights participants
    insights_participants_action: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Insights shareholders
    insights_shareholders_action: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    insights_shareholders_tab: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Data
    data_add: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    data_add_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    data_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Automatic payments
    auto_payments_continue: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    auto_payments_payments_section: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    auto_payments_not_ready_payments_section: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Contacts
    contacts_add: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contacts_add_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contacts_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    contacts_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Documents
    documents_add: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    documents_add_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    documents_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Participants
    participants_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    participants_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Campaigns
    campaigns_add_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    campaigns_add: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    campaigns_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Outbox
    outbox_view_list: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    outbox_attachments: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    outbox_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Mailing
    mailing_send: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Warrants
    manage_warrants_add: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    manage_warrants_add_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    manage_warrants_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    manage_warrants_import: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    manage_warrants_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    warrant_holders_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    warrant_holders_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    warrant_insights_expiring_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    warrant_insights_outstanding_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    create_continue: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    create_legal_continue: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    create_payment_review: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    create_order: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // First login
    onboarding_start: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_acct_setup: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_acct_setup_more: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_subscription_skip: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_subscription_back: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_subscription_help: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_upload_skip: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_upload_back: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_upload_help: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_tour_request: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_tour_request_complete: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_tour_complete: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Dashboard
    dashboard_tab: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    dashboard_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    dashboard_chart_filter: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Payments
    payment_add_method: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Email Campaigns
    email_campaigns_analytics_download: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    email_campaigns_create_test: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    email_campaigns_create_start: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    email_campaigns_create_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    email_campaigns_create_back: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    email_campaigns_create_continue: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    email_campaigns_create_send: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    email_campaigns_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Investment Advisers
    investment_advisors_search_helper: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    investment_advisors_search: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // SMS Campaigns
    sms_campaigns_create_test: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    investment_advisors_advanced_search_filters: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    sms_campaigns_create_start: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    sms_campaigns_create_save: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    sms_campaigns_create_back: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    sms_campaigns_create_continue: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    sms_campaigns_create_send: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    sms_campaigns_actions: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Web builder
    webtools_start_setup: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    webtools_go_back: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    webtools_preview_site: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    webtools_save_continue: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    webtools_publish_site: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    webtools_edit_website: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    webtools_visit_website: {
      amplitude: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
  },
  requests: {
    // Login
    login_request: {
      amplitude: true,
      endpoint: 'auth/token',
      method: 'post',
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Onboarding
    onboarding_subscription_continue: {
      amplitude: true,
      endpoint: 'accountManagement/reportRequests',
      method: 'post',
      parameters: {
        platform_url: window.location.origin,
      },
    },
    onboarding_upload_continue: {
      amplitude: true,
      endpoint: 'accountManagement/reportReviews',
      method: 'post',
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Onboarding get help
    onboarding_help_request: {
      amplitude: true,
      endpoint: 'accountManagement/reportRequestsContact',
      method: 'post',
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Events
    events_search: {
      amplitude: true,
      endpoint: 'events',
      method: 'get',
      isSearch: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    shareholders_search: {
      amplitude: true,
      endpoint: 'shareholders',
      method: 'get',
      isSearch: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Insights shareholder
    insights_shareholders_search: {
      amplitude: true,
      endpoint: 'dataFiles',
      method: 'get',
      isSearch: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Participants
    participants_search: {
      amplitude: true,
      endpoint: 'marketMakers',
      method: 'get',
      isSearch: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Mailing
    mailing_request: {
      amplitude: true,
      endpoint: 'mailer',
      method: 'post',
      parameters: {
        platform_url: window.location.origin,
      },
    },
    create_order_request: {
      amplitude: true,
      endpoint: 'onboarding/payment',
      method: 'post',
      parameters: {
        platform_url: window.location.origin,
      },
    },
    // Email Campaigns
    campaigns_search: {
      amplitude: true,
      endpoint: 'campaigns',
      method: 'get',
      isSearch: true,
      parameters: {
        platform_url: window.location.origin,
      },
    },
  },
};

const config = { ...defaultConfig };

export const configResponse = {
  SUCCESS: {
    parameters: {
      status: '',
      code: '',
    },
  },
  ERROR: {
    parameters: {
      status: '',
      code: '',
      error: '',
    },
  },
  FAIL: {
    parameters: {
      status: '',
      code: '',
      error: '',
    },
  },
};

export default config;
